// extracted by mini-css-extract-plugin
export default {"HeaderTitle":"HeaderTitle_HeaderTitle__KSNol"};